export enum DataTableCellFormatType {
  CountryName = 'countryName',
  Text = 'text',
  Number = 'number',
  Price = 'price',
  Float = 'float',
  FloatPoint = 'floatPoint',
  Date = 'date',
}

export const DataTableTextCells = {
  [DataTableCellFormatType.CountryName]: 1,
  [DataTableCellFormatType.Text]: 1,
  [DataTableCellFormatType.Date]: 1,
};
